import React, { useState } from 'react';
import { Info } from 'lucide-react';

/**
 * Botón pequeño "ver texto" que despliega/colapsa el texto (descripcion) de una
 * cobertura. Colapsado por defecto. Si no hay descripcion, no renderiza nada.
 *
 * Reutilizable en: Admin (catálogo), Pólizas y Solicitudes (formularios/vistas).
 */
export default function CoberturaDesc({ descripcion, label = 'Ver texto' }) {
  const [open, setOpen] = useState(false);
  const texto = (descripcion || '').trim();
  if (!texto) return null;

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        title={open ? 'Ocultar texto de la cobertura' : 'Ver texto de la cobertura'}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 4,
          background: 'none', border: 'none', cursor: 'pointer',
          color: 'var(--sky-light)', fontSize: 11, fontWeight: 600,
          fontFamily: 'var(--font)', padding: 0,
        }}
      >
        <Info size={13} /> {open ? 'Ocultar texto' : label}
      </button>
      {open && (
        <div style={{
          marginTop: 6, padding: '10px 12px', width: '100%',
          background: 'rgba(var(--sky-rgb),0.08)', border: '1px solid rgba(var(--sky-rgb),0.2)',
          borderRadius: 6, fontSize: 12, color: '#C9D6E5', lineHeight: 1.5,
          whiteSpace: 'pre-wrap',
        }}>
          {texto}
        </div>
      )}
    </span>
  );
}
